import React from 'react'
import PropTypes from 'prop-types'
import { FullscreenModal } from 'belle-js'
import connectModal from 'connectModal'
import modalStyles from '../Modals.module.scss'

const JointAccountHolderInfoModal = (props) => {
  const {
    isOpen,
    closeModal,
    isActiveModal,
  } = props

  return (
    <FullscreenModal
      isOpen={isOpen}
      isActiveModal={isActiveModal}
      className={modalStyles.Modal}
      onClose={closeModal}
      testId="jointAccountHolderInfoModal">
      <h2>
        What is a joint account holder?
      </h2>

      <p>
        The joint account holder is a member of the account who can
        withdraw from and deposit to the joint account.
        Usually, joint accounts are shared between close relatives,
        spouses/partners, or business partners.
      </p>

      <div className={modalStyles.actions}>
        <button
          type="button"
          className="button button--primary"
          onClick={closeModal}>
          Got it!
        </button>
      </div>
    </FullscreenModal>
  )
}

JointAccountHolderInfoModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  isActiveModal: PropTypes.bool.isRequired
}


export default connectModal(JointAccountHolderInfoModal, 'jointAccountHolderInfoModal')



// WEBPACK FOOTER //
// ./src/components/Onboarding/Modals/JointAccountHolderInfoModal/JointAccountHolderInfoModal.jsx